export type GuestVacationLocation = {
  active: boolean;
  label: string;
  lat: number;
  lon: number;
};

const STORAGE_KEY = 'lafete:guest-vacation-location';

export function readGuestVacationLocation(): GuestVacationLocation | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<GuestVacationLocation>;
    if (
      typeof parsed.active !== 'boolean' ||
      typeof parsed.label !== 'string' ||
      typeof parsed.lat !== 'number' ||
      typeof parsed.lon !== 'number'
    ) {
      return null;
    }
    return parsed as GuestVacationLocation;
  } catch {
    return null;
  }
}

export function writeGuestVacationLocation(location: GuestVacationLocation) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(location));
    window.dispatchEvent(new CustomEvent('lafete:guest-location-changed'));
  } catch {}
}

export function clearGuestVacationLocation() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent('lafete:guest-location-changed'));
  } catch {}
}